module.exports = __webpack_public_path__ + "deQOb6xYFjuKhT0iy/illo-couple-phone.svg";